import { createRouter, createWebHistory } from "vue-router";
import HelloWorld from "../views/HelloWorld.vue";
import LoginIndex from "../views/LoginIndex.vue";
import HandOver from "../views/HandOver.vue";
import HandoverUpload from "../views/HandoverUpload.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: LoginIndex },
    { path: "/uploadmaterial", component: HelloWorld },
    { path: "/handover", component: HandOver },
    { path: "/handoverUpload", component: HandoverUpload },
  ],
});
export default router